import script from "./GeneralSeguradoEditRepository.vue?vue&type=script&lang=js"
export * from "./GeneralSeguradoEditRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__